var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blog-callout",class:("blog-callout--" + _vm.type)},[_c('span',{staticClass:"blog-callout__icon"},[_c('i',{class:_vm.icon})]),_vm._v(" "),_c('div',{staticClass:"blog-callout__body"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }